var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.app.bootstrap.country === "us"
    ? _c("div", { staticClass: "dashboard-card dashboard-card-resource" }, [
        _c("div", { staticClass: "dashboard-card-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                x: "0px",
                y: "0px",
                width: "100",
                height: "104",
                viewBox: "0 0 100 104",
                "enable-background": "new 0 0 100 104",
                "xml:space": "preserve",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "#33C2B2",
                  d: "M48.69,13.96c-0.93,0-1.69-0.76-1.69-1.69V1.69C47,0.76,47.76,0,48.69,0s1.69,0.76,1.69,1.69v10.57C50.38,13.2,49.62,13.96,48.69,13.96z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#FFAD29",
                  d: "M35.47,17.5c-0.58,0-1.15-0.3-1.47-0.85l-2.64-4.58c-0.47-0.81-0.19-1.84,0.62-2.31c0.81-0.47,1.84-0.19,2.31,0.62l2.64,4.58c0.47,0.81,0.19,1.84-0.62,2.31C36.05,17.43,35.76,17.5,35.47,17.5z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#D91C1C",
                  d: "M25.79,27.18c-0.29,0-0.58-0.07-0.84-0.23l-9.16-5.29c-0.81-0.47-1.09-1.5-0.62-2.31c0.47-0.81,1.5-1.09,2.31-0.62l9.16,5.29c0.81,0.47,1.09,1.5,0.62,2.31C26.95,26.87,26.38,27.18,25.79,27.18z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#122E45",
                  d: "M71.59,27.18c-0.58,0-1.15-0.3-1.47-0.85c-0.47-0.81-0.19-1.84,0.62-2.31l9.16-5.29c0.81-0.47,1.84-0.19,2.31,0.62c0.47,0.81,0.19,1.84-0.62,2.31l-9.16,5.29C72.17,27.1,71.87,27.18,71.59,27.18z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#0D5E99",
                  d: "M61.91,17.5c-0.29,0-0.58-0.07-0.84-0.23c-0.81-0.47-1.09-1.5-0.62-2.31l2.64-4.58c0.47-0.81,1.5-1.09,2.31-0.62c0.81,0.47,1.09,1.5,0.62,2.31l-2.64,4.58C63.06,17.2,62.49,17.5,61.91,17.5z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#125480",
                  d: "M97.38,45.3c0-2.49-1.37-4.65-3.38-5.83v5.82c0,0,0,0,0,0.01v32.79l3.38,3.25V45.3z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#125480",
                  d: "M53.98,91.79c-0.94,0-1.69,0.76-1.69,1.69c0,1.98-1.61,3.6-3.59,3.6c-1.98,0-3.6-1.61-3.6-3.6c0-0.94-0.76-1.69-1.69-1.69H6.77c-1.87,0-3.38-1.52-3.38-3.38V45.3c0,0,0,0,0-0.01v-5.82C1.37,40.65,0,42.81,0,45.3v43.1c0,3.73,3.04,6.77,6.77,6.77h35.15c0.76,3.03,3.51,5.29,6.77,5.29c3.26,0,6.01-2.25,6.77-5.29h19.87l0-3.38H53.98z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#0D5E99",
                  d: "M53.98,86.5c-2.12,0-4.01,0.97-5.29,2.48c-1.28-1.5-3.16-2.48-5.29-2.48H8.08V37.01H43.4c1.98,0,3.6,1.61,3.6,3.6v42.3c0,0.94,0.76,1.69,1.69,1.69s1.69-0.76,1.69-1.69v-42.3c0-1.98,1.61-3.6,3.59-3.6H89.3v36.57l3.38,3.25V37.01c0-1.87-1.52-3.38-3.38-3.38H53.98c-2.12,0-4.01,0.97-5.29,2.48c-1.28-1.5-3.16-2.48-5.29-2.48H8.08c-1.87,0-3.38,1.52-3.38,3.38V86.5c0,1.87,1.52,3.38,3.38,3.38H43.4c1.98,0,3.6,1.61,3.6,3.6c0,0.94,0.76,1.69,1.69,1.69s1.69-0.76,1.69-1.69c0-1.98,1.61-3.6,3.59-3.6h21.36l0-3.38H53.98z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#D91C1C",
                  d: "M22.25,58.16h10.57c0.93,0,1.69-0.76,1.69-1.69s-0.76-1.69-1.69-1.69H22.25c-0.93,0-1.69,0.76-1.69,1.69S21.32,58.16,22.25,58.16z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#33C2B2",
                  d: "M38.11,68.88H16.96c-0.93,0-1.69,0.76-1.69,1.69c0,0.93,0.76,1.69,1.69,1.69h21.15c0.93,0,1.69-0.76,1.69-1.69C39.81,69.63,39.05,68.88,38.11,68.88z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#FFAD29",
                  d: "M38.11,61.83H16.96c-0.93,0-1.69,0.76-1.69,1.69c0,0.93,0.76,1.69,1.69,1.69h21.15c0.93,0,1.69-0.76,1.69-1.69C39.81,62.59,39.05,61.83,38.11,61.83z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#122E45",
                  d: "M90.41,103.98c-0.66,0-1.28-0.38-1.56-1.03l-3.1-7.28l-4.47,2.68c-0.52,0.31-1.17,0.32-1.7,0.02c-0.53-0.3-0.86-0.86-0.86-1.47l-0.01-24.83c0-0.68,0.4-1.29,1.03-1.56c0.62-0.26,1.35-0.13,1.84,0.34l17.91,17.19c0.44,0.42,0.62,1.05,0.47,1.64c-0.15,0.59-0.6,1.05-1.19,1.22l-5.03,1.38l3.1,7.28c0.18,0.41,0.18,0.88,0.01,1.3s-0.49,0.75-0.91,0.93l-4.86,2.07C90.86,103.94,90.64,103.98,90.41,103.98z M86.55,91.54c0.18,0,0.35,0.03,0.52,0.08c0.46,0.15,0.84,0.5,1.03,0.95l3.2,7.51l1.75-0.75l-3.2-7.51c-0.19-0.45-0.18-0.96,0.03-1.4c0.21-0.44,0.6-0.77,1.08-0.9l4.02-1.1L82.09,76.05l0.01,17.87l3.58-2.14C85.95,91.62,86.25,91.54,86.55,91.54z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dashboard-card-title dashboard-typography" },
            [
              _c("span", { staticClass: "resource-library-mentor" }, [
                _vm._v(_vm._s(_vm.eyebrow)),
              ]),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "resource-library-title" }, [
                _vm._v(_vm._s(_vm.headline)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("p", {
            staticClass: "typography",
            domProps: { innerHTML: _vm._s(_vm.body) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dashboard-card-actions" }, [
          _c(
            "a",
            {
              staticClass: "dashboard-action-link",
              attrs: { href: _vm.url, target: "_blank" },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.link) + "\n      "),
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("navigate_next"),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "color-header" }, [
      _c("div", { staticClass: "color-band" }),
      _vm._v(" "),
      _c("div", { staticClass: "color-band" }),
      _vm._v(" "),
      _c("div", { staticClass: "color-band" }),
      _vm._v(" "),
      _c("div", { staticClass: "color-band" }),
      _vm._v(" "),
      _c("div", { staticClass: "color-band" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }